import { Injectable } from '@angular/core';
import createAnalytics, {
  ZipAnalyticsInstance,
  withDefaults,
  DEFAULT_CROSS_DOMAIN_CSS_CLASS,
} from '@zip/analytics-core';
import { environment } from 'src/environments/environment';
import {
  ExperimentEnrolmentEvent,
  ExperimentEnrolmentSchema,
  UIClickEventData,
  UIClickSchema,
  UIInputEventData,
  UIInputSchema,
} from './events';

export { DEFAULT_CROSS_DOMAIN_CSS_CLASS };

@Injectable({
  providedIn: 'root',
})
export class TrxService {
  analytics: ZipAnalyticsInstance;
  private static EnrolledInExperiments: Record<string, boolean> = {};

  constructor() {
    this.analytics = createAnalytics({
      ...withDefaults(
        environment.zipAnalytics.appId,
        environment.zipAnalytics.namespace,
        environment.zipAnalytics.endpoint,
      ),
      pageTracking: {
        enabled: true,
        linkClickTracking: {
          trackContent: true,
          enabled: true,
        },
      },
      fullStory: {
        enabled: true,
        samplingMethod: 'static' as never,
        staticSampleSize: 10,
        fsLibOptions: {
          orgId: 'ZEQ9T',
          host: 'fullstory.com',
          script: 'edge.fullstory.com/s/fs.js',
          namespace: 'FS',
        },
      },
    });
  }

  get domainUserId() {
    return this.analytics.state.tracker.getDomainUserId();
  }

  async setCustomerId(customerId: string) {
    await this.analytics.identify(customerId);
  }

  async sendPageEvent() {
    await this.analytics.page();
  }

  async sendExperimentEvent(experimentName: string, experimentValue: string) {
    if (TrxService.EnrolledInExperiments[experimentName]) return;

    const data: ExperimentEnrolmentEvent = {
      experiment_id: experimentName,
      variation_id: experimentValue,
    };

    await this.analytics.trackEvent({
      schema: ExperimentEnrolmentSchema.v1_0_0,
      data,
    });

    TrxService.EnrolledInExperiments[experimentName] = true;
  }

  async sendUIClickEvent(event: UIClickEventData) {
    await this.analytics.trackEvent({
      schema: UIClickSchema.v1_0_0,
      data: event,
    });
  }

  async sendUIInputEvent(event: UIInputEventData) {
    await this.analytics.trackEvent({
      schema: UIInputSchema.v1_0_0,
      data: event,
    });
  }
}
